export default __webpack_public_path__ + "static/media/letalk-small-logo-white.cab3b07d.svg";